module.exports = "/_next/static/files/1656018178ed6e318b34f5fd90115886.svg";